import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useMemo } from 'react';
import { ReactComponent as ChangeUserIcon } from '../../../../../../../../../../img/action-change-user.svg';
import { ReactComponent as CannotIcon } from '../../../../../../../../../../img/action-deactivate.svg';
import { ReactComponent as ReviewIcon } from '../../../../../../../../../../img/icon-review.svg';
import {ReactComponent as DateIcon} from "../../../../../../../../../../img/icon-date.svg";

// Images
import { ReactComponent as LeaveNoteIcon } from '../../../../../../../../../../img/action-leave-note.svg';
import Icon from '../../../../../../../../Common/Icon';
import {
  STATUS_CANNOT_DO,
  STATUS_SOLVED,
  STATUS_APPROVAL_IN_PROGRESS,
  STATUS_APPROVAL_APPROVED,
  STATUS_APPROVAL_REJECTED,
  STATUS_APPROVAL_RETURN_TO_SUBMITTER,
  STATUS_UPCOMING,
  STATUS_FUTURE
} from '../../../../../../../../../Services/api/ActionItems';

//  Styles
import './style.scss';

/**
 * @callback onClick
 */
/**
 * @callback handleActionsCb
 */

/**
 * Task actions popup
 * @param {onClick} onAction
 * @param {handleActionsCb} onActions
 * @param {number} status
 */
const CalendarTaskPopup = ({ onAction, onActions, status, isPermissionAvailable, task }) => {
  const calendar_body = document.getElementsByClassName('calendar_body');
  const popupRef = useRef(null);
  /**
   * Close popup if clicked on outside of task
   */
  const handleClickOutside = useCallback(
    (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onActions(event);
      }
    },
    [onActions]
  );

  const handleClickAction = useCallback(
    (event, action) => {
      onAction(event, action);
      onActions(event);
    },
    [onAction, onActions]
  );

  const renderIcon = useCallback(
    (icon) => (
      <Icon width="15" height="15" color="primaryColor">
        {icon}
      </Icon>
    ),
    []
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
  }, [handleClickOutside]);

  useEffect(() => {
    return () => {
        // Anything in here is fired on component unmount.
        if(calendar_body && calendar_body.length > 0) calendar_body[0].classList.remove('calendar_body--min-body-height');
    }
}, [])

  /**
   * Detect if the popup is out of viewport
   */
  const viewportDetect = () => {
    if(calendar_body && calendar_body.length > 0) calendar_body[0].classList.remove('calendar_body--min-body-height');
    const element = popupRef.current;
    const bounding = element.getBoundingClientRect();
    const container = document.getElementsByClassName("headers");
    const headerBounding = container[0].getBoundingClientRect();
      if (bounding.top < headerBounding.top) {
        if(calendar_body[0].offsetHeight < 250){
          calendar_body[0].classList.add('calendar_body--min-body-height')
        }
        element.classList.remove("TimelineTaskPopup--out-of-viewport");
      } else {
        element.classList.add("TimelineTaskPopup--out-of-viewport");
      }
  }

  useEffect(() => {
    viewportDetect();
    window.addEventListener('resize', viewportDetect);
  });

  const showCannotDo = useMemo(() => {
    return ![STATUS_SOLVED, STATUS_CANNOT_DO, STATUS_UPCOMING, STATUS_FUTURE].includes(status)
  }, [status])

  const disabledChangeTaskDate = () => {
    return task.leo_created ? false : true;
  }

  return (
    <div className="TimelineTaskPopup TimelineTaskPopup--out-of-viewport" ref={popupRef}>
      <h3 className="TimelineTaskPopup__title">Task</h3>
      <div>
        <div className="TimelineTaskPopup__item Pointer" onClick={(e) => handleClickAction(e, 'addNotes')}>
          {renderIcon(<LeaveNoteIcon alt="add-note" />)}
          <span>Leave a note</span>
        </div>
        <div className="TimelineTaskPopup__item Pointer" onClick={(e) => handleClickAction(e, 'assign')}>
          {renderIcon(<ChangeUserIcon alt="assign-user" />)}
          <span>Assign User</span>
        </div>
        {showCannotDo && (
          <div className="TimelineTaskPopup__item Pointer" onClick={(e) => handleClickAction(e, 'cannot')}>
            {renderIcon(<CannotIcon alt="cannot-do" />)}
            <span>Cannot do</span>
          </div>
        )}
        {isPermissionAvailable('permission_change_task_date') && (
            <div className="TimelineTaskPopup__item Pointer" onClick={(e) => handleClickAction(e, 'changeDate')} disabled={disabledChangeTaskDate()}>
              {renderIcon(<DateIcon alt="change-date" />)}
              <span>Change Date</span>
            </div>
        )}
        {[STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_APPROVED, STATUS_APPROVAL_REJECTED, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(status) && (
          <div className="TimelineTaskPopup__item Pointer" onClick={(e) => handleClickAction(e, 'toReview')}>
            {renderIcon(<ReviewIcon alt="review" />)}
            <span>Review</span>
          </div>
        )}
      </div>
    </div>
  );
};

CalendarTaskPopup.propTypes = {
  onAction: PropTypes.func.isRequired,
  onActions: PropTypes.func.isRequired,
  status: PropTypes.number,
  isPermissionAvailable: PropTypes.func,
  task: PropTypes.object
};

export default CalendarTaskPopup;
